import { render, staticRenderFns } from "./DocumentPrint4.vue?vue&type=template&id=5207fab5&scoped=true"
import script from "./DocumentPrint4.vue?vue&type=script&lang=js"
export * from "./DocumentPrint4.vue?vue&type=script&lang=js"
import style0 from "./DocumentPrint4.vue?vue&type=style&index=0&id=5207fab5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5207fab5",
  null
  
)

export default component.exports